import axios_ from "../utils/axios";

export default {
  /**
   * 分类+标签列表
   */
  getClassifyTagList(params) {
    return axios_("GET", "api/pandagpt/v1/teamLabel/labelLists", params);
  },
  /**
   * 添加分类
   */
  addClassify(params) {
    return axios_("POST", "api/pandagpt/v1/teamLabel/addClassify", params);
  },
  /**
   * 添加标签
   */
  addTag(params) {
    return axios_("POST", "api/pandagpt/v1/teamLabel/addLabel", params);
  },
  /**
   * 修改 标签/分类
   */
  updateClassifyTag(params) {
    return axios_("POST", "api/pandagpt/v1/teamLabel/update", params);
  },
  /**
   * 删除 标签/分类
   */
  delClassifyTag(params) {
    return axios_("POST", "api/pandagpt/v1/teamLabel/del", params);
  },
};
